import "./card.sass";
import DOMPurify from "dompurify";
import PropTypes from "prop-types";

export default function Card({
  pic,
  title,
  text,
  btnColor,
  btnText,
  link,
  reverse = false,
}) {
  return (
    <div className={`card${reverse ? " reverse" : ""}`}>
      <div className="card-pic">
        <img src={pic} alt="" />
      </div>
      <div className="card-content">
        <div className="card-title">
          <span>{title}</span>
        </div>
        <div className="card-frame">
          <div className="card-text">
            <div
              dangerouslySetInnerHTML={{
                __html: DOMPurify.sanitize(text),
              }}
            ></div>
          </div>
          <div className="card-btn">
            <a
              href={link}
              className={`${btnColor}${link === "" ? " disabled" : ""}`}
              target="_blank"
              rel="noopener noreferrer"
            >
              <span>{btnText}</span>
            </a>
          </div>
        </div>
      </div>
    </div>
  );
}

Card.propTypes = {
  pic: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  text: PropTypes.string.isRequired,
  btnColor: PropTypes.string,
  btnText: PropTypes.string,
  link: PropTypes.string,
  reverse: PropTypes.bool,
};
